import { ScheduleHeader as MantineScheduleHeader, ScheduleHeaderProps } from "@mantine/schedule";

export const ScheduleHeader = (props: ScheduleHeaderProps) => {
  return <MantineScheduleHeader {...props} />;
};

ScheduleHeader.Control = MantineScheduleHeader.Control;
ScheduleHeader.Previous = MantineScheduleHeader.Previous;
ScheduleHeader.Next = MantineScheduleHeader.Next;
ScheduleHeader.Today = MantineScheduleHeader.Today;
ScheduleHeader.ViewSelect = MantineScheduleHeader.ViewSelect;
ScheduleHeader.MonthYearSelect = MantineScheduleHeader.MonthYearSelect;

export default ScheduleHeader;
